import { useState } from 'react';
import { Box, Button, FormLabel, MenuItem, Select, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import GlobalDialogContent from '../GlobalDialogContent';
import { RootState } from '../../../redux/store';
import { closeDialog } from '../../../redux/reducer/dialogSlice';
import { showSnackbar } from '../../../redux/reducer/snackbarSlice';
import { setModuleRefresh } from '../../../redux/reducer/registration/RefreshSlice';
import { VerifyBeneficiaryDocService } from '../../../utils/services/collaboration-agreement/collaboration-agreement.service';

const BeneficiaryDocumentStatusDialog = () => {
    const dispatch = useDispatch();
    const { payload } = useSelector((state: RootState) => state.dialog);
    const [status, setStatus] = useState(payload?.document?.status === 'rejected' ? 'rejected' : 'approved');
    const [remarks, setRemarks] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!remarks.trim()) {
            dispatch(showSnackbar({ type: 'error', message: 'Please enter remark' }));
            return;
        }

        setLoading(true);
        const { code, message } = await VerifyBeneficiaryDocService({
            Beneficiary_uuid: payload?.beneficiary_uuid,
            document_uuid: payload?.document?.uuid,
            document_type: payload?.document_type || payload?.document?.document_type,
            status,
            remarks,
        });

        if (code === 200) {
            if (payload?.tabStorageKey) sessionStorage.setItem(payload.tabStorageKey, '2');
            dispatch(showSnackbar({ type: 'success', message: message || 'Document status updated successfully' }));
            dispatch(setModuleRefresh({ moduleName: 'user_details', refresh: true }));
            dispatch(closeDialog());
        } else {
            dispatch(showSnackbar({ type: 'error', message: message || 'Something went wrong' }));
        }
        setLoading(false);
    };

    return (
        <GlobalDialogContent
            dialogBody={
                <>
                    <Box sx={{ mb: 2 }}>
                        <FormLabel>Status <span style={{ color: 'red' }}>*</span></FormLabel>
                        <Select fullWidth size="small" value={status} onChange={(event) => setStatus(event.target.value)} sx={{ mt: 0.5 }}>
                            <MenuItem value="approved">Approved</MenuItem>
                            <MenuItem value="rejected">Rejected</MenuItem>
                        </Select>
                    </Box>
                    <Box>
                        <FormLabel>Remark <span style={{ color: 'red' }}>*</span></FormLabel>
                        <TextField fullWidth size="small" multiline minRows={3} value={remarks} onChange={(event) => setRemarks(event.target.value)} placeholder="Enter remark" sx={{ mt: 0.5 }} />
                    </Box>
                </>
            }
            dialogFooter={
                <Button variant="contained" color={status === 'approved' ? 'success' : 'error'} onClick={handleSubmit} disabled={loading}>
                    {loading ? 'Submitting...' : status === 'approved' ? 'Approve' : 'Reject'}
                </Button>
            }
        />
    );
};

export default BeneficiaryDocumentStatusDialog;
